import { render, staticRenderFns } from "./BundleEditor.vue?vue&type=template&id=ee830122"
import script from "./BundleEditor.vue?vue&type=script&lang=js"
export * from "./BundleEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports